/**
 * Wave 2 — suppress operational shell banners on client-record surfaces so
 * coordinators see Journey content above the fold (GB P1-1 triple-banner stack).
 *
 * Demo workspace banner always renders; tenant-setup and subscription quantity
 * banners are demoted on coordinator-heavy paths where page content carries
 * operational context (client records, home-care, care plans, assessments).
 */
const OPERATIONAL_BANNER_SUPPRESSED_PREFIXES = [
  '/clients',
  '/home-care',
  '/care-plans',
  '/assessments',
] as const;

export function suppressOperationalShellBanners(pathname: string | null | undefined): boolean {
  if (!pathname) return false;
  return OPERATIONAL_BANNER_SUPPRESSED_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
